var AuthingConf = {
  appId: "62d11c68c3e1b2e125e6304d",
  host: "https://6pen.authing.cn"
};

export { AuthingConf };
